<template>
  <div>
    <Header />
    <div class="your-orders-container">
      <div class="container">
        <div class="your-orders-title-header">
          <div class="your-orders-title">Order History</div>
          <div class="your-orders-back-btn">
            <router-link to="/"> Home </router-link>
          </div>
        </div>
        <!-- <div class="your-orders-body">
          <div class="row">
            <div class="col-lg-6">
                
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <div class="latis">
      <div class="container">
        <!-- <Location style="display: none" /> -->

        <div class="container_profile">
          <div v-if="order_data.length <= 0" class="msg_order">
            <p style="text-align: center; margin-top: 30px">No Records</p>
          </div>

          <div class="col-lg-4 col-sm-4 col-md-12 col-xs-12 card_det" v-for="(orderdetail, index) in order_data"
            :key="index">
            <div class="card">
              <div class="title">Order Summary</div>
              <div class="info">
                <div class="row">
                  <div class="col-md-6">
                    <span id="heading">Date</span><br />
                    <span id="details">{{
                        convertDate(orderdetail.orderDateTime)
                    }}</span>
                  </div>
                  <div class="col-md-6">
                    <span id="heading">Order No.</span><br />
                    <span id="details">{{ orderdetail.order_id }}</span>
                  </div>
                </div>
              </div>

              <div class="info">
                <div class="row">
                  <div class="col-md-6">Order Status</div>
                  <div class="col-md-6" style="text-transform: capitalize">
                    {{ orderdetail.order_state }}
                  </div>
                </div>
              </div>

              <div class="total">
                <div class="row">
                  <div class="col-md-6">Order Total</div>
                  <div class="col-md-6">
                    <big>{{ currency_symbol }}. {{ orderdetail.order_total }}</big>
                  </div>
                </div>
              </div>

              <div class="total">
                <div class="row">
                  <div class="col-md-6" style="padding: 2px; width: 50% !important">
                    <b-button style="background-color: #ffbb0e; color: #fff" variant="outline-danger"
                      @click="viewOrder(orderdetail.order_id)">
                      <b-icon-eye></b-icon-eye> View Order
                    </b-button>
                  </div>
                  <div class="col-md-6" style="padding: 2px; width: 50% !important">
                    <b-button style="background-color: #000; color: #fff" v-if="
                      digital_order_setting.reject_order == 1 &&
                      orderdetail.order_state != 'acknowledged' &&
                      orderdetail.order_state != 'food ready' &&
                      orderdetail.order_state != 'dispatched' &&
                      orderdetail.order_state != 'fulfilled' &&
                      orderdetail.order_state != 'cancelled' &&
                      orderdetail.order_state != 'payment incomplete' &&
                      orderdetail.order_state != 'payment pending'
                    " variant="outline-success" block @click="
  cancelOrder(
    orderdetail.order_id,
    orderdetail.store_id,
    orderdetail.phone
  )
">Cancel Order <b-icon-x-square></b-icon-x-square>
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal size="lg" title="Large Modal" hide-footer hide-header id="modal-center-single-order">
      <div class="modal-body">
        <!-- <h4 style="padding-bottom:10px">Choose Order Type</h4> -->

        <header style="background-color: #343a40; color: #fff">
          <span @click="closeOrderModal" class="close-button topright">&times;</span>
        </header>

        <div class="card" v-for="(orderdetail, index) in single_order" :key="index">
          <div class="title">Order Details</div>
          <div class="info">
            <div class="row">
              <div class="col-md-7">
                <span id="heading">Date</span><br />
                <span id="details">{{
                    convertDate(orderdetail.orderDateTime)
                }}</span>
              </div>
              <div class="col-md-5">
                <span id="heading">Order No.</span><br />
                <span id="details">{{ orderdetail.order_id }}</span>
              </div>
            </div>
          </div>

          <div class="pricing">
            <div class="row">
              <table class="table">
                <thead style="background-color: #ffbb0e; color: #fff">
                  <tr>
                    <th>Item</th>
                    <th style="text-align: center">Quantity</th>
                    <th>Price</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="menu in orderdetail.tmpos_order_child" :key="menu.id">
                    <td>
                      {{ menu.title }}
                    </td>
                    <td style="text-align: center">
                      {{ menu.quantity }}
                    </td>
                    <td v-if="menu.discount == 0">
                      {{ menu.price }}
                    </td>
                    <td v-else-if="menu.discount > 0">
                      {{ menu.price * menu.quantity }}
                    </td>
                    <td>
                      {{ menu.price * menu.quantity }}
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="paymentorderdetailstotal">
                <div class="table-responsive ordersSummarydetails">
                  <table>
                    <tr>
                      <td>Subtotal</td>
                      <td>
                        {{ currency_symbol }}. {{ orderdetail.order_subtotal }}
                      </td>
                    </tr>

                    <tr v-for="charges in orderdetail.tmpos_order_charges" :key="charges.id">
                      <td style="text-transform: capitalize">
                        {{ charges.title }}
                      </td>
                      <td>{{ currency_symbol }}. {{ charges.value }}</td>
                    </tr>

                    <!-- <tr>
                      <td>CGST</td>
                      <td>
                        {{ currency_symbol }}.
                        {{ orderdetail.order_level_total_taxes / 2 }}
                      </td>
                    </tr>
                    <tr>
                      <td>SGST</td>
                      <td>
                        {{ currency_symbol }}.
                        {{ orderdetail.order_level_total_taxes / 2 }}
                      </td>
                    </tr> -->
                    <tr>
                      <td>VAT (Inc)</td>
                      <td>
                        {{ currency_symbol }}.
                        {{ orderdetail.order_level_total_taxes }}
                      </td>
                    </tr>
                    <tr v-if="orderdetail.coupan_calculated_amt">
                      <td>Discount</td>
                      <td>
                        {{ currency_symbol }}.
                        {{ orderdetail.coupan_calculated_amt }}
                      </td>
                    </tr>
                    <tr>
                      <td><b>Total</b></td>
                      <td>
                        <b>{{ currency_symbol }}.
                          {{ orderdetail.order_total }}</b>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div class="total">
            <div class="row">
              <div class="col-md-4">
                <!--   <b-button style="background-color: #ffbb0e;color:#fff" 
                   variant="outline-danger" 
                   block 
                   @click="repeatOrder(orderdetail)">
                    Repeat Order <b-icon-arrow-clockwise></b-icon-arrow-clockwise>
                   </b-butto> -->
              </div>
              <div class="col-md-4">
                <b-button style="background-color: #000; color: #fff" v-if="
                  digital_order_setting.reject_order == 1 &&
                  orderdetail.order_state != 'acknowledged' &&
                  orderdetail.order_state != 'food ready' &&
                  orderdetail.order_state != 'dispatched' &&
                  orderdetail.order_state != 'fulfilled' &&
                  orderdetail.order_state != 'cancelled' &&
                  orderdetail.order_state != 'payment incomplete' &&
                  orderdetail.order_state != 'payment pending'
                " variant="outline-success" block @click="
  cancelOrder(
    orderdetail.order_id,
    orderdetail.store_id,
    orderdetail.phone
  )
">Cancel Order <b-icon-x-square></b-icon-x-square>
                </b-button>
              </div>

              <div class="col-md-4">
                <b-button style="background-color: #ffbb0e; color: #fff" variant="outline-danger" block
                  @click="closeModalOrder">
                  Close
                </b-button>
              </div>
            </div>
          </div>

          <!-- <div class="pricing">

       <div class="row">
            <div class="col-md-6"> 
               <span id="name" style="font-weight:700">ITEM</span> 
            </div>
            <div class="col-md-3"> 
               <span id="name" style="font-weight:700">QUANTITY</span> 
            </div>
            <div class="col-md-3"> 
               <span id="price" style="font-weight:700">
                  PRICE
               </span> 
            </div>
        </div>

        <div class="row" v-for="menu in orderdetail.tmpos_order_child" :key="menu.id">
            <div class="col-md-6"> 
               <span id="name">{{menu.title}}</span> 
            </div>
            <div class="col-md-3"> 
               <span id="price">
                  {{menu.quantity}}
               </span> 
            </div>
            <div class="col-md-3"> 
               
               <span id="price" v-if="menu.discount == 0"> 
                  {{currency_symbol}}. {{menu.price * menu.quantity}}
               </span>
               <span id="price" v-else-if="menu.discount > 0">
                     {{currency_symbol}}. {{menu.price * menu.quantity}}
               </span>
            </div>
        </div>

        <hr class="order_hr">

        <div class="row">
            <div class="col-md-9"> 
               <span id="name">Subtotal</span> 
            </div>
            <div class="col-md-3"> 
               <span id="price">{{currency_symbol}}. {{orderdetail.order_subtotal}}</span> 
            </div>


            <span v-for="charges in orderdetail.tmpos_order_charges" :key="charges.id">

               <div class="col-md-9"> 
               <span id="name">{{charges.title}}</span> 
            </div>
            <div class="col-md-3"> 
               <span id="price">{{currency_symbol}}. {{charges.value}}</span> 
            </div>
            </span>
            

            <div class="col-md-9"> 
               <span id="name">CGST</span> 
            </div>
            <div class="col-md-3"> 
               <span id="price">{{currency_symbol}}. {{orderdetail.order_level_total_taxes / 2}}</span> 
            </div>

            <div class="col-md-9"> 
               <span id="name">SGST</span> 
            </div>
            <div class="col-md-3"> 
               <span id="price">{{currency_symbol}}. {{orderdetail.order_level_total_taxes / 2}}</span> 
            </div>
        </div>
    </div>
    <div class="total">
        <div class="row">
            <div class="col-md-8">Order Total</div>
            <div class="col-md-4"><big>{{currency_symbol}}. {{orderdetail.order_total}}</big></div>
        </div>
    </div>
  -->
        </div>
      </div>
    </b-modal>

    <Footer />
  </div>
</template>


<script>
import Header from "./Header";
import Footer from "./Footer";
import { mapGetters, mapActions } from "vuex";

import $ from "jquery";

export default {
  name: "Order",
  computed: {
    ...mapGetters(["cartItems"]),
    ...mapGetters(["outletInformation"]),
    ...mapGetters(["getOrderType"]),
    ...mapGetters(["cartGST"]),
    ...mapGetters(["additionalCharges"]),
    ...mapGetters(["getAdditionalCharges"]),
    ...mapGetters(["cartTotalPrice"]),
    ...mapGetters(["cartItemCount"]),
    ...mapGetters(["digital_order_setting"]),
    ...mapGetters(["allMenuItems"]),
  },
  data () {
    return {
      // order_id:'',
      order_data: [],
      userinfolocal: localStorage.getItem("userinfo")
        ? JSON.parse(localStorage.getItem("userinfo"))
        : [],
      digi_setting: [],
      single_order: [],
      currency_symbol: localStorage.getItem("currency_symbol"),
    };
  },
  components: {
    Header,
    Footer,
  },
  mixins: [Header, Footer],
  methods: {
    ...mapActions(["getMenuItems"]),
    closeOrderModal () {
      this.$bvModal.hide("modal-center-single-order");
    },
    getOrders () {
      let order_detail = {
        store_id: this.userinfolocal.store_id,
        phone: this.userinfolocal.phone,
      };

      let currentObj = this;
      //  console.log("order detail is "+JSON.stringify(order_detail))
      currentObj.axios
        .post("orderbycust", order_detail)
        .then(function (response) {
          currentObj.order_data = response.data.data;

          // alert(JSON.stringify(this.order_data.order_data))
        })
        .catch((error) => {
          console.log(error);
        });
    },
    convertDate (ord_date) {
      var d = new Date(ord_date);

      //  alert(ord_date)
      //  d.getTime()
      //var date = new Date(ord_date);
      // var dt = d.getDay()+'-' +  d.getFullYear()+'-' + (d.getMonth()+1) + '-'+d.getDate();//prints expected format.
      var dt =
        d.getUTCFullYear() +
        "-" +
        (d.getUTCMonth() + 1) +
        "-" +
        d.getUTCDate() +
        " " +
        d.getHours() +
        ":" +
        d.getMinutes() +
        ":" +
        d.getSeconds();
      //   alert(dt)

      var newdt = new Date(dt);

      return (
        newdt.toDateString() +
        " " +
        newdt.getUTCHours() +
        ":" +
        newdt.getUTCMinutes() +
        ":" +
        newdt.getUTCSeconds()
      );
    },
    cancelOrder (order_id, store_id, phone) {
      let currentObj = this;

      let order_data = {
        store_id: store_id,
        phone: phone,
        new_order_state: "cancelled",
        order_id: order_id,
      };

      currentObj.axios
        .put("rejectbycust/", order_data)
        .then(function (response) {
          let status = JSON.stringify(response.data.status);

          //  console.log(status)

          if (status == 200) {
            // currentObj.$router.push("/ViewCartComponent").catch(()=>{});
            currentObj.$bvToast.toast(response.data.msg, {
              variant: "danger",
              toaster: "b-toaster-bottom-left",
              solid: true,
            });

            currentObj.getOrders();
            currentObj.closeOrderModal();
          }

          if (status == 204) {
            // currentObj.$router.push("/ViewCartComponent").catch(()=>{});
            currentObj.$bvToast.toast(response.data.msg, {
              variant: "danger",
              toaster: "b-toaster-bottom-left",
              solid: true,
            });

            currentObj.getOrders();
          }
        })
        .catch((error) => {
          //this.errorMessage = error.message;
          alert("There was an error! " + error);
        });
    },
    viewOrder (orderid) {
      this.single_order = [];
      this.single_order = this.order_data.filter((orderdetail) => {
        return orderdetail.order_id == orderid;
      });

      this.$bvModal.show("modal-center-single-order");

      //alert("Single order is "+ JSON.stringify(this.single_order))
    },
    closeModalOrder () {
      this.$bvModal.hide("modal-center-single-order");
    },
    repeatOrder (orderdetail) {
      //     console.log("orderdetail "+JSON.stringify(orderdetail))

      //alert('order type ' +this.getOrderType + ' local storage '+ localStorage.getItem('deliverytype'))

      //console.log("allMenuItems "+JSON.stringify(this.allMenuItems))
      //console.log("orderdetail "+JSON.stringify(orderdetail.tmpos_order_child))

      // let keys = Object.keys(orderdetail.tmpos_order_child.reduce((a, {item_id}) => Object.assign(a, {[item_id] : undefined}), {}));
      //console.log("keys "+JSON.stringify(keys))
      //let filtered = this.allMenuItems.filter(({item_id}) => !keys.includes(item_id))

      //console.log("filtered "+JSON.stringify(filtered))

      if (
        (this.getOrderType == "null" &&
          localStorage.getItem("deliverytype") == "null") ||
        (this.getOrderType == null &&
          localStorage.getItem("deliverytype") == null)
      ) {
        alert("order type " + this.getOrderType);
        this.openModalOrderType();
      }

      if (
        this.getOrderType != "null" &&
        localStorage.getItem("deliverytype") != "null" &&
        this.getOrderType != null &&
        localStorage.getItem("deliverytype") != null
      ) {
        this.allMenuItems.forEach((items) => {
          orderdetail.tmpos_order_child.find((element) => {
            if (items.item_id == element.item_id) {
              // alert("element "+items.title)

              //console.log("element "+JSON.stringify(items))

              //  this.addToCart(items)

              let menuitem = JSON.stringify(items);
              //  console.log(JSON.parse(menuitem))

              //let qty = 1

              this.$store.dispatch("addMenuToCart", {
                items: JSON.parse(menuitem),
              });
            }
          });
        });
      }
    },
  },
  created () {
    this.getMenuItems();
    this.getOrders();

    this.digi_setting = localStorage.getItem("digital_order_setting");

    this.$nextTick(function () {
      // $("#divTest").scrollTop($("#divTest")[0].scrollHeight);

      $(window).scrollTop(0);
    });
  },
};
</script>

<style scoped>
.panel {
  margin-bottom: 20px;
  background-color: #fff;
  border: 1px solid transparent;
  border-radius: 4px;
  -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}

.card {
  width: 100%;
  margin: 10px 0px;
  padding: 4vh 0;
  box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-top: 3px solid #ffbb0e;
  border-bottom: 3px solid #ffbb0e;
  border-left: none;
  border-right: none;
}

@media (max-width: 768px) {
  .card {
    width: 100%;
  }
}

@media (max-width: 360px) {
  [class*="col-"] {
    width: 100%;
    float: left;
    min-height: 1px;
  }
}

.title {
  color: #ffbb0e;
  font-weight: 600;
  margin-bottom: 2vh;
  padding: 0 8%;
  font-size: initial;
}

#details {
  font-weight: 400;
}

.info {
  padding: 5% 8%;
}

.info .col-5 {
  padding: 0;
}

#heading {
  color: grey;
  line-height: 6vh;
}

.pricing {
  background-color: #ddd3;
  padding: 2vh 8%;
  font-weight: 400;
  line-height: 2.5;
}

.pricing .col-3 {
  padding: 0;
}

.total {
  padding: 2vh 8%;
  color: #ffbb0e;
  font-weight: bold;
}

.total .col-3 {
  padding: 0;
}

.footer {
  padding: 0 8%;
  font-size: x-small;
  color: black;
}

.footer img {
  height: 5vh;
  opacity: 0.2;
}

.footer a {
  color: #ffbb0e;
}

.footer .col-10,
.col-2 {
  display: flex;
  padding: 3vh 0 0;
  align-items: center;
}

.footer .row {
  margin: 0;
}

#progressbar {
  margin-bottom: 3vh;
  overflow: hidden;
  color: #ffbb0e;
  padding-left: 0px;
  margin-top: 3vh;
}

#progressbar li {
  list-style-type: none;
  font-size: x-small;
  width: 25%;
  float: left;
  position: relative;
  font-weight: 400;
  color: rgb(160, 159, 159);
}

#progressbar #step1:before {
  content: "";
  color: #ffbb0e;
  width: 5px;
  height: 5px;
  margin-left: 0px !important;
}

#progressbar #step2:before {
  content: "";
  color: #fff;
  width: 5px;
  height: 5px;
  margin-left: 32%;
}

#progressbar #step3:before {
  content: "";
  color: #fff;
  width: 5px;
  height: 5px;
  margin-right: 32%;
}

#progressbar #step4:before {
  content: "";
  color: #fff;
  width: 5px;
  height: 5px;
  margin-right: 0px !important;
}

#progressbar li:before {
  line-height: 29px;
  display: block;
  font-size: 12px;
  background: #ddd;
  border-radius: 50%;
  margin: auto;
  z-index: -1;
  margin-bottom: 1vh;
}

#progressbar li:after {
  content: "";
  height: 2px;
  background: #ddd;
  position: absolute;
  left: 0%;
  right: 0%;
  margin-bottom: 2vh;
  top: 1px;
  z-index: 1;
}

.progress-track {
  padding: 0 8%;
}

#progressbar li:nth-child(2):after {
  margin-right: auto;
}

#progressbar li:nth-child(1):after {
  margin: auto;
}

#progressbar li:nth-child(3):after {
  float: left;
  width: 68%;
}

#progressbar li:nth-child(4):after {
  margin-left: auto;
  width: 132%;
}

#progressbar li.active {
  color: black;
}

#progressbar li.active:before,
#progressbar li.active:after {
  background: #ffbb0e;
}
</style>